const config = {
  TABS: {
    ACTIVE_CONVERSATION: 'active_conversation',
    CONVERSATIONS: 'conversations',
    INFORMATION: 'information'
  },
  SEND_MESSAGE_PROPERTIES: {
    MAIN_CONTENT: 'sendmessagemaincontent',
    PAYLOAD: 'sendmessagepayload'
  }
}

export default config
